import React, { useEffect, useState } from "react";
import DefaultLayout from "../../Defaultlayout/DefaultLayout";
import { _delete, _get } from "../services/service_api";
import {
  API_BASE_URL,
  DELETE_SPECIALITY,
  directToken,
  LIST_OF_SPECIALITY,
} from "../services/end_points";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  Alert,
  Button,
  Card,
  Col,
  Grid,
  Input,
  Modal,
  Row,
  Table,
  Typography,
} from "antd";
import AddAssignSpeciality from "./AddAssignSpeciality";
import EditAssignSpeciality from "./EditAssignSpeciality";
import { useRoleData } from "../Data/Roledata";
const { useBreakpoint } = Grid;
const AssignSpeciality = ({ handleRole }) => {
  const { column, rows } = useRoleData({ handleRole });
  const isAdmin = rows.some((row) => row.userType === "Admin");
  const [alert, setAlert] = useState(null);
  const [open, setOpen] = useState(false);
  const [specialities, setSpecialities] = useState([]);
  const [formdata, setFormData] = useState([]);
  const [editing, setEditing] = useState(false);
  const userId = localStorage.getItem("userid");
  const [filteredSpecialities, setFilteredSpecialities] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(8);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const handleEditforopup = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
    setIsEditing(true);
  };

  const showModal = () => setIsModalVisible(true);
  const closeModal = () => {
    setIsModalVisible(false);
    setIsEditing(false);
  };

  const handleDelete = async (data) => {
    try {
      const response = await _delete(
        `${API_BASE_URL}${DELETE_SPECIALITY}${data}`,
        directToken
      );
      setAlert({
        type: "success", // Set this to 'error' if needed
        message: response.data.message || "Speciality Deleted!",
      });

      fetchData(); // Refresh data after deletion
    } catch (error) {
      console.error("Error deleting speciality:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await _get(
        `${API_BASE_URL}${LIST_OF_SPECIALITY}/${userId}`,
        directToken
      );
      if (response.data && response.data.list) {
        setSpecialities(response.data.list);
        setFilteredSpecialities(response.data.list);
      } else {
        console.error("Response data is not as expected:", response.data);
      }
    } catch (error) {
      console.error("Error fetching specialities:", error.message);
    }
  };

  const handleAddLocation = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditing(false);
    fetchData();
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    const filtered = specialities.filter((specialityItem) =>
      specialityItem.specialities_names.toLowerCase().includes(value)
    );
    setFilteredSpecialities(filtered);
  };

  const dynamicData = filteredSpecialities.map((dataItem, index) => ({
    key: index,
    serialNumber: (
      <Typography
        display="block"
        variant="button"
        fontWeight="medium"
        fontSize="1.2rem"
      >
        {(currentPage - 1) * pageSize + index + 1}
      </Typography>
    ),
    speciality: (
      <Typography
        display="block"
        variant="button"
        fontWeight="medium"
        fontSize="1.2rem"
      >
        {dataItem.specialities_names}
      </Typography>
    ),
    hospitalName: (
      <Typography
        display="block"
        variant="button"
        fontWeight="medium"
        fontSize="1.2rem"
      >
        {dataItem.hospitalName}
      </Typography>
    ),
    Action: (
      <div>
        <Button
          size="small"
          style={{
            fontSize: "12px",
            border: "1px solid #0899f9",
            color: "#0899f9",
          }}
          onClick={() => handleEditforopup(dataItem)}
        >
          <EditOutlined />
        </Button>

        {rows[0]?.id === 1 && (
          <Button
            size="small"
            style={{
              marginLeft: "5px",
              fontSize: "12px",
              border: "1px solid #941717",
              color: "#941717",
            }}
            onClick={() => handleDelete(dataItem.id)}
          >
            <DeleteOutlined />
          </Button>
        )}
      </div>
    ),
  }));

  const columns = [
    {
      title: "S.No",
      dataIndex: "serialNumber",
      key: "serialNumber",
      onCell: () => ({
        style: {
          fontSize: "20px",
        },
      }),
    },
    {
      title: "Speciality",
      dataIndex: "speciality",
      key: "speciality",
    },
    {
      title: "Hospital Name",
      dataIndex: "hospitalName",
      key: "hospitalName",
    },
    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      onCell: () => ({
        style: {
          width: "250px",
        },
      }),
    },
  ];
  const screens = useBreakpoint();
  let modalWidth;
  if (screens.xl) {
    modalWidth = 450;
  } else if (screens.lg) {
    modalWidth = 450;
  } else if (screens.md) {
    modalWidth = 450;
  } else if (screens.sm) {
    modalWidth = 450;
  } else {
    modalWidth = 450;
  }
  const updateUserList = (newUser) => {
    setSpecialities((prevUser) => {
      // Check if the user is being added or updated
      const index = prevUser.findIndex(
        (user) => user.userid === newUser.userid
      );
      if (index === -1) {
        // Add new user
        return [...prevUser, newUser];
      } else {
        // Update existing user
        const updatedUsers = [...prevUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });
    setFilteredSpecialities((prevFilteredUser) => {
      const index = prevFilteredUser.findIndex(
        (user) => user.userid === newUser.userid
      );
      if (index === -1) {
        // Add new user
        return [...prevFilteredUser, newUser];
      } else {
        // Update existing user
        const updatedUsers = [...prevFilteredUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });
    fetchData();
  };
  return (
    <DefaultLayout>
      <Card style={{ width: "100%", minHeight: "600px", height: "100%" }}>
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <h2>Speciality List</h2>
          </Col>
          <Col xs={24} sm={24} md={10} lg={10} xl={10}>
            <Input
              style={{ width: "100%", height: "45px" }}
              placeholder="Search Speciality"
              onChange={handleSearch}
            />
          </Col>
          <Col
            xs={24}
            sm={24}
            md={6}
            lg={6}
            xl={6}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              style={{
                backgroundColor: "#6499f1",
                color: "white",
                fontSize: "14px",
                fontWeight: "500",
                borderRadius: "10px",
                width: "100%",
                height: "48px",
                maxWidth: "200px",
              }}
              onClick={showModal}
            >
              Create Speciality
            </Button>
          </Col>
        </Row>

        <Row>
          <Col xs={24} sm={24} md={22} lg={20} xl={24}>
            <div style={{ width: "100%", overflowX: "auto" }}>
              <Table
                columns={columns}
                dataSource={dynamicData}
                rowKey="key"
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  onChange: (page, pageSize) => {
                    setCurrentPage(page);
                    setPageSize(pageSize);
                  },
                }}
              />
            </div>
          </Col>
        </Row>
        <Modal
          title={isEditing ? "Edit AssignSpeciality" : "Add AssignSpeciality"}
          visible={isModalVisible}
          onCancel={closeModal}
          footer={null}
          width={modalWidth}
        >
          {isEditing ? (
            <EditAssignSpeciality data={selectedRecord} />
          ) : (
            <AddAssignSpeciality updateUserList={updateUserList} />
          )}
          {/* <AddAssignSpeciality /> */}
        </Modal>
      </Card>
    </DefaultLayout>
  );
};
export default AssignSpeciality;
